import { Box, Button, Flex, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React, { useState } from "react"
import styled from "styled-components"

import ArticleCard from "./article-card"
import ArticleCardLoading from "./article-card-loading"
import Breadcrumb from "./breadcrumb"
import fetchArticles from "./hoc/fetch-articles"

const ArticleContainer = styled(Box)`
  display: grid;
  ${(props) => props.theme.mediaQueries.tablet`
    grid-gap: 16px;
    grid-template-columns: 1fr 1fr 1fr;
  `}
  ${(props) => props.theme.mediaQueries.desktop`
    grid-gap: 24px;
  `}
`

const LoadMore = styled(Button).attrs((props) => ({
  bg: "primary",
  color: "white",
  fontSize: "18px",
  height: "48px",
  lineHeight: "18px",
  width: "260px",
  ...props,
}))``

const Homepage = ({ articles, getArticles, isLoading, page }) => {
  const [loadingMore, setLoadingMore] = useState(false)

  const featuredArticles = articles.filter((article) => article.featured)
  const blogArticles = articles.filter((article) => !article.featured)

  const onLoadMore = async () => {
    setLoadingMore(true)
    await getArticles((page?.current_page || 1) + 1)
    setLoadingMore(false)
  }

  return (
    <>
      <Breadcrumb />
      <Typography
        as="h1"
        fontSize="32px"
        fontWeight="700"
        lineHeight="36px"
        mb={5}
      >
        {sl.config.site_title} Blog
      </Typography>
      {isLoading ? (
        <ArticleCardLoading featured />
      ) : (
        featuredArticles.map((featured) => (
          <ArticleCard article={featured} featured key={featured.url_path} />
        ))
      )}
      <ArticleContainer>
        {blogArticles.map((blogArticle) => (
          <ArticleCard article={blogArticle} key={blogArticle.url_path} />
        ))}
        {(isLoading || loadingMore) &&
          [...Array(6)].map((_, i) => (
            <ArticleCardLoading key={`article-loading-${i}`} />
          ))}
      </ArticleContainer>
      {page?.current_page < page?.total_page_count && (
        <Flex justifyContent="center" pb={{ _: 0, tablet: 5 }} pt={1} px="20px">
          <LoadMore
            disabled={loadingMore}
            loading={loadingMore}
            onClick={() => onLoadMore()}
          >
            {loadingMore ? "Loading" : "View More"}
          </LoadMore>
        </Flex>
      )}
    </>
  )
}

Homepage.propTypes = {
  articles: PropTypes.array,
  getArticles: PropTypes.func,
  isLoading: PropTypes.bool,
  page: PropTypes.object,
}

export default fetchArticles(Homepage)
